import { ChangeDetectionStrategy, Component, computed, ElementRef, inject, input, linkedSignal, OnInit, output, viewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatHint, MatLabel } from '@angular/material/select';
import { NavigationService } from '@common/services/navigation-service';
import { Store } from '@ngrx/store';
import { selectI18N } from '@src/suite/common/store/i18n/selectors/i18n.selectors';
import { NavigationSection } from '@src/suite/common/store/navigation/models/navigation.models';

@Component({
    selector: 'st-section-label',
    imports: [FormsModule, MatFormField, MatHint, MatIcon, MatInput, MatLabel],
    templateUrl: './section-label.html',
    styleUrl: './section-label.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-section-label',
    },
})
export class SectionLabelComponent implements OnInit {
    navigationService = inject(NavigationService);
    store = inject(Store);
    languageSettings = this.store.selectSignal(selectI18N)();

    readonly section = input<NavigationSection>();

    readonly cancelEdit = output<NavigationSection>();
    readonly save = output<NavigationSection>();

    readonly sectionLabel = viewChild<ElementRef>('sectionLabel');
    // TOOD ACL
    readonly canEdit = computed(() => true);

    readonly currentValue = linkedSignal(() => this.section().Label);
    readonly inEditMode = linkedSignal(() => this.section().InEditMode);
    readonly isNewSection = linkedSignal(() => !!this.section().IsNewSection);

    ngOnInit() {
        if (this.canEdit() && this.inEditMode()) {
            setTimeout(() => {
                this.sectionLabel().nativeElement.focus();
            });
        }
    }

    public onCancel(event: Event) {
        event.stopPropagation();
        const updatedSection = { ...this.section(), InEditMode: false };
        this.cancelEdit.emit(updatedSection);
    }

    public onSave(event: Event) {
        event.stopPropagation();
        const updatedSection = { ...this.section(), Label: this.currentValue(), InEditMode: false };
        this.save.emit(updatedSection);
    }
}
